var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app_nav_bar"},[_c('div',{staticClass:"nav_bar_wrap"},[_c('NavLeft'),_c('div',{staticClass:"nav_right"},[_c('NavRight')],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }